import React from 'react';
import { Link } from 'react-router-dom';
import {
  FiSettings,
  FiCheckCircle,
  FiArrowRight,
  FiPhoneCall,
  FiZap,
  FiShield,
  FiTool,
  FiAward,
  FiTarget,
  FiEye,
  FiActivity,
  FiMonitor,
  FiClipboard,
  FiUsers,
} from 'react-icons/fi';

import pSteelPole from '../assest/NEW RA.png';
import pConcretePole from '../assest/product image transparent/Concrete Poles.png';
import pJoist from '../assest/product image transparent/High_Beam_Rolled_Steel_Joists.png.png';
import pControlPanel from '../assest/product image transparent/Control_Panels_and_Distribution_Panel.png.png';
import tTransformer1 from '../assest/transformer/transformer_1.jpg';
import factoryHero from '../assest/manufacturing/manufatrig new.jpg';
import visionImg from '../assest/manufacturing/sections/vm_vision.png';
import missionImg from '../assest/manufacturing/sections/vm_mission.png';
import testTransformerImg from '../assest/manufacturing/sections/test_transformer.png';
import testPanelImg from '../assest/manufacturing/sections/test_panel.png';
import testPoleImg from '../assest/manufacturing/sections/test_pole.png';
import gp1 from '../assest/manufacturing/sections/gp_1.png';
import gp2 from '../assest/manufacturing/sections/gp_2.png';
import gp3 from '../assest/manufacturing/sections/gp_3.png';
import gp4 from '../assest/manufacturing/sections/gp_4.png';
import gp5 from '../assest/manufacturing/sections/gp_5.png';
import gp6 from '../assest/manufacturing/sections/gp_6.png';
import Reveal from '../common/Reveal';
import Counter from '../common/Counter';
import ManufacturingGallery from '../common/ManufacturingGallery';

const testingGroups = [
  {
    icon: FiZap,
    title: 'Transformer Testing',
    img: testTransformerImg,
    points: [
      'Ratio Test (TTR)',
      'Winding Resistance Test',
      'No Load & Load Loss Test',
      'Dielectric Withstand Test',
      'Oil Breakdown Voltage Test',
      'Temperature Rise Test',
    ],
  },
  {
    icon: FiSettings,
    title: 'Control Panel Testing',
    img: testPanelImg,
    points: [
      'Insulation Resistance Test',
      'Dielectric Withstand Test',
      'Functional Operation Test',
      'Protection Relay Test',
      'Wiring & Continuity Check',
      'Busbar & Component Check',
    ],
  },
  {
    icon: FiTool,
    title: 'Pole Testing',
    img: testPoleImg,
    points: [
      'Dimensional Inspection',
      'Galvanization Thickness Test',
      'Weld Quality Inspection',
      'Load / Deflection Test',
      'Verticality & Strength Test',
      'Surface Finish Inspection',
    ],
  },
];

const governancePillars = [
  {
    icon: FiUsers,
    title: 'Structured Reviews',
    desc: 'Weekly production and quality review meetings with every department head.',
  },
  {
    icon: FiMonitor,
    title: 'Real-Time Monitoring',
    desc: 'Control-room dashboards tracking output, downtime and quality metrics as they happen.',
  },
  {
    icon: FiClipboard,
    title: 'On-Floor Audits',
    desc: 'Regular inspection walks and documented checks at every work station.',
  },
  {
    icon: FiActivity,
    title: 'Safety Governance',
    desc: 'Toolbox talks and safety briefings before every shift, without exception.',
  },
];

const governanceGallery = [
  { img: gp2, caption: 'Field Inspection' },
  { img: gp3, caption: 'Control Room Monitoring' },
  { img: gp4, caption: 'Team Planning' },
  { img: gp5, caption: 'Quality Check' },
  { img: gp6, caption: 'Safety Briefing' },
];

const lines = [
  {
    title: 'Distribution Transformers',
    tag: 'DTR · 25 – 20000 kVA',
    desc: 'In-house manufacturing of distribution transformers across the full 25 kVA to 20000 kVA range, built and tested to spec before dispatch.',
    img: tTransformer1,
    href: '/products#transformers',
  },
 {
    title: 'All Types of Electric Poles',
    tag: 'PSC · Rail · Tubular · Octagonal · RSJ',
    desc: 'Full range of pole structures fabricated to spec — PSC Pole, Rail Pole, Tubular Pole, Octagonal Pole and RSJ Pole — for transmission and distribution lines.',
    img: pSteelPole,
    href: '/products#all-types-of-electric-poles',
  },
  {
    title: 'Control & Distribution Panels',
    tag: 'Panels',
    desc: 'Control panels and distribution panels engineered for reliable, safe power distribution in the field.',
    img: pControlPanel,
    href: '/products#control-panel',
  },
];

const whyInHouse = [
  'Quality stays in our hands, start to finish',
  'Faster turnaround — no dependence on third-party vendors',
  'Products built to each client\u2019s exact specification',
  'Consistent testing and quality checks before dispatch',
];

export default function Manufacturing() {
  return (
    <div className="bg-white">
      {/* ---------------- HERO: FULL-BLEED FACTORY PHOTO ---------------- */}
      <section className="relative overflow-hidden text-white">
        <div className="absolute inset-0">
          <img
            src={factoryHero}
            alt="Prithviraj manufacturing floor"
            className="h-full w-full object-cover"
          />
         <div className="absolute inset-0 bg-gradient-to-r from-[#071E4A]/55 via-[#071E4A]/20 to-transparent" />
<div className="absolute inset-0 bg-gradient-to-t from-[#071E4A]/35 via-transparent to-transparent" />
        </div>

        <div className="relative mx-auto max-w-7xl px-4 py-24 sm:px-6 sm:py-32 lg:px-8 lg:py-40">
          <span className="inline-block animate-fadeInUp rounded-full bg-brand-orange/20 px-4 py-1 text-xs font-bold uppercase tracking-wide text-brand-orange ring-1 ring-brand-orange/30  ">
            Our Services — Manufacturing
          </span>
          <h1
            className="mt-5 animate-fadeInUp text-4xl font-black uppercase leading-[0.95] tracking-tight sm:text-6xl lg:text-7xl hero-shimmer block text-brand-orange"
            style={{ animationDelay: '80ms' }}
          >
            Manufacturing
          </h1>
          <p
            className="mt-5 max-w-xl animate-fadeInUp text-base font-medium text-white/85 sm:text-lg"
            style={{ animationDelay: '160ms' }}
          >
            Powered by people, driven by precision, and guided by a commitment to performance, safety
            &amp; long-term reliability — engineered in-house at our own workshop in Barauni, Begusarai,
            Bihar.
          </p>

          <div className="mt-9 flex flex-wrap gap-8 animate-fadeInUp" style={{ animationDelay: '240ms' }}>
            {[
              { value: 20000, suffix: ' kVA', label: 'Largest DTR built in-house' },
              { value: 3, suffix: '', label: 'Manufacturing lines' },
              { value: 17, suffix: '+', label: 'Years of hands-on experience' },
            ].map((s) => (
              <div key={s.label}>
                <p className="text-2xl font-extrabold sm:text-3xl">
                  <Counter value={s.value} suffix={s.suffix} />
                </p>
                <p className="mt-1 text-xs font-medium uppercase tracking-wide text-white/60">{s.label}</p>
              </div>
            ))}
          </div>

          <Link
            to="/contact"
            className="mt-9 inline-flex animate-fadeInUp items-center gap-2 rounded-full bg-brand-orange px-6 py-3 text-sm font-bold uppercase tracking-wide text-white transition hover:-translate-y-0.5 hover:bg-brand-orangedark"
            style={{ animationDelay: '320ms' }}
          >
            Talk to Our Manufacturing Team <FiArrowRight />
          </Link>

          <div
            className="mt-8 flex flex-wrap gap-2.5 animate-fadeInUp"
            style={{ animationDelay: '380ms' }}
          >
            {['Government-Approved Manufacturer', 'In-House Quality Checks', 'Built To Client Spec'].map((b) => (
              <span
                key={b}
                className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3.5 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-white/85 ring-1 ring-white/20 backdrop-blur"
              >
                <FiCheckCircle className="text-brand-orange" size={13} />
                {b}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* ---------------- ABOUT / WHAT WE MANUFACTURE ---------------- */}
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <Reveal className="mx-auto max-w-2xl text-center">
          <h2 className="text-4xl font-extrabold uppercase leading-none sm:text-5xl lg:text-6xl">
            <span className="hero-shimmer block text-brand-orange">
              WHAT WE MANUFACTURE
            </span>
          </h2>
          <h3 className="mt-4 text-2xl font-bold text-navy sm:text-3xl lg:text-4xl">
            Built in-house, tested before it leaves our floor
          </h3>
          <p className="mt-3 text-slate-600">
            As a manufacturing &amp; trading company, we have built a solid foundation and infrastructure for manufacturing
            electrical goods, so every product meets our own quality bar before it reaches a client.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-8 lg:grid-cols-3">
          {lines.map((line, i) => (
            <Reveal key={line.title} delay={i * 120}>
              <Link
                to={line.href}
                className="group flex h-full flex-col overflow-hidden rounded-3xl border border-slate-100 bg-white shadow-sm transition duration-300 hover:-translate-y-1.5 hover:border-brand-orange/30 hover:shadow-xl"
              >
                <div className="relative flex aspect-[4/3] items-center justify-center overflow-hidden bg-slate-50">
                  {line.img ? (
                    <img
                      src={line.img}
                      alt={line.title}
                      className="h-full w-full object-contain p-8 transition duration-500 group-hover:scale-110"
                      loading="lazy"
                    />
                  ) : (
                    <div className="flex flex-col items-center gap-2 text-slate-300">
                      <FiZap size={40} />
                      <span className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">
                        Photo coming soon
                      </span>
                    </div>
                  )}
                  <span className="absolute left-4 top-4 rounded-full bg-navy/90 px-3 py-1 text-[10px] font-bold uppercase tracking-wide text-white">
                    {line.tag}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <h3 className="text-lg font-extrabold text-navy">{line.title}</h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{line.desc}</p>
                  <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-brand-orange">
                    View products
                    <FiArrowRight className="transition duration-300 group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      {/* ---------------- MANUFACTURING GALLERY (ANIMATED SLIDESHOW) ---------------- */}
      <ManufacturingGallery />

      {/* ---------------- WHY IN-HOUSE ---------------- */}
      <section className="bg-slate-50 py-16 sm:py-20">
        <div className="mx-auto grid max-w-7xl items-center gap-10 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
          <Reveal direction="right">
            <h2 className="text-4xl font-extrabold uppercase leading-none sm:text-5xl lg:text-6xl">
              <span className="hero-shimmer block text-brand-orange">
                WHY IN-HOUSE
              </span>
            </h2>
            <h3 className="mt-4 text-2xl font-bold text-navy sm:text-3xl lg:text-4xl">
              Quality we control, end to end
            </h3>
            <p className="mt-3 text-slate-600">
              From tendering to execution we track every stage — planning, procurement and
              implementation — which is exactly why we chose to build our own manufacturing line rather
              than depend entirely on outside vendors.
            </p>
            <ul className="mt-6 space-y-3">
              {whyInHouse.map((point) => (
                <li key={point} className="flex items-start gap-3 text-slate-700">
                  <FiCheckCircle className="mt-0.5 shrink-0 text-brand-orange" size={20} />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal direction="left" delay={150}>
            <div className="relative rounded-3xl bg-white p-8 shadow-sm">
              <div className="grid grid-cols-2 gap-4">
                {[pConcretePole, pSteelPole, pJoist, pControlPanel].map((img, i) => (
                  <div
                    key={i}
                    className={`overflow-hidden rounded-2xl bg-slate-50 shadow-sm ${i % 2 === 1 ? 'mt-6' : ''}`}
                  >
                    <img src={img} alt="" className="h-32 w-full object-contain p-4" />
                  </div>
                ))}
              </div>
              <div className="absolute -right-4 -top-4 animate-float rounded-2xl bg-navy px-4 py-2 text-xs font-bold text-white shadow-lg">
                Barauni Workshop
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      {/* ---------------- VISION & MISSION ---------------- */}
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="space-y-14">
          <div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14">
            <Reveal direction="right">
              <div className="flex items-center gap-4">
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-navy text-white">
                  <FiEye size={24} />
                </span>
                <h2 className="text-2xl font-extrabold uppercase tracking-tight text-navy sm:text-3xl">
                  Our <span className="block">Vision</span>
                </h2>
              </div>
              <span className="mt-3 block h-1 w-14 rounded-full bg-brand-orange" />
              <p className="mt-4 max-w-md text-slate-600">
                To be a leading force in the power sector, delivering innovative, reliable and
                sustainable solutions that empower communities and drive a brighter future.
              </p>
            </Reveal>
            <Reveal direction="left" delay={120}>
              <div className="overflow-hidden rounded-3xl shadow-sm">
                <img src={visionImg} alt="Our Vision" className="h-64 w-full object-cover sm:h-80" loading="lazy" />
              </div>
            </Reveal>
          </div>

          <div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14">
            <Reveal direction="right" className="order-2 lg:order-1">
              <div className="overflow-hidden rounded-3xl shadow-sm">
                <img src={missionImg} alt="Our Mission" className="h-64 w-full object-cover sm:h-80" loading="lazy" />
              </div>
            </Reveal>
            <Reveal direction="left" delay={120} className="order-1 lg:order-2">
              <div className="flex items-center gap-4">
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-navy text-white">
                  <FiTarget size={24} />
                </span>
                <h2 className="text-2xl font-extrabold uppercase tracking-tight text-navy sm:text-3xl">
                  Our <span className="block">Mission</span>
                </h2>
              </div>
              <span className="mt-3 block h-1 w-14 rounded-full bg-brand-orange" />
              <p className="mt-4 max-w-md text-slate-600">
                To deliver high-quality products and services through innovation, skilled expertise,
                and a commitment to safety and excellence. We aim to build lasting relationships by
                exceeding customer expectations and contributing to the nation&rsquo;s power
                infrastructure growth.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      {/* ---------------- QUALITY TESTING ---------------- */}
      <section className="bg-slate-50 py-16 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Reveal className="mx-auto max-w-2xl text-center">
            <h2 className="text-4xl font-extrabold uppercase leading-none sm:text-5xl lg:text-6xl">
              <span className="hero-shimmer block text-brand-orange">
                QUALITY TESTING
              </span>
            </h2>
            <h3 className="mt-4 text-2xl font-bold text-navy sm:text-3xl lg:text-4xl">
              Every product, tested before it ships
            </h3>
            <p className="mt-3 text-slate-600">
              Dedicated test setups for transformers, panels and poles — so nothing leaves our floor
              without being verified against spec.
            </p>
          </Reveal>

          <div className="mt-12 space-y-10">
            {testingGroups.map((group, i) => {
              const Icon = group.icon;
              const imgFirst = i % 2 === 1;
              return (
                <div key={group.title} className="grid items-center gap-8 rounded-3xl bg-white p-6 shadow-sm sm:p-8 lg:grid-cols-2 lg:gap-12">
                  <Reveal direction={imgFirst ? 'right' : 'right'} className={imgFirst ? 'order-2 lg:order-1' : ''}>
                    {imgFirst ? (
                      <div className="overflow-hidden rounded-2xl">
                        <img src={group.img} alt={group.title} className="h-56 w-full object-cover sm:h-64" loading="lazy" />
                      </div>
                    ) : (
                      <div>
                        <div className="flex items-center gap-3">
                          <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-navy/5 text-navy">
                            <Icon size={20} />
                          </span>
                          <h3 className="text-lg font-extrabold text-navy sm:text-xl">{group.title}</h3>
                        </div>
                        <ul className="mt-5 grid grid-cols-1 gap-2.5 sm:grid-cols-2">
                          {group.points.map((p) => (
                            <li key={p} className="flex items-start gap-2 text-sm text-slate-600">
                              <FiCheckCircle className="mt-0.5 shrink-0 text-brand-orange" size={16} />
                              <span>{p}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </Reveal>
                  <Reveal direction="left" delay={120} className={imgFirst ? 'order-1 lg:order-2' : ''}>
                    {imgFirst ? (
                      <div>
                        <div className="flex items-center gap-3">
                          <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-navy/5 text-navy">
                            <Icon size={20} />
                          </span>
                          <h3 className="text-lg font-extrabold text-navy sm:text-xl">{group.title}</h3>
                        </div>
                        <ul className="mt-5 grid grid-cols-1 gap-2.5 sm:grid-cols-2">
                          {group.points.map((p) => (
                            <li key={p} className="flex items-start gap-2 text-sm text-slate-600">
                              <FiCheckCircle className="mt-0.5 shrink-0 text-brand-orange" size={16} />
                              <span>{p}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ) : (
                      <div className="overflow-hidden rounded-2xl">
                        <img src={group.img} alt={group.title} className="h-56 w-full object-cover sm:h-64" loading="lazy" />
                      </div>
                    )}
                  </Reveal>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ---------------- GOVERNANCE & PERFORMANCE ---------------- */}
     <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
  <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-14">
    <Reveal direction="right">
      <h2 className="text-4xl font-extrabold uppercase leading-none sm:text-5xl lg:text-6xl">
        <span className="hero-shimmer block text-brand-orange">
          GOVERNANCE &amp; PERFORMANCE
        </span>
      </h2>
      <h3 className="mt-4 text-2xl font-bold text-navy sm:text-3xl lg:text-4xl">
        Accountability at every level
      </h3>
      <p className="mt-3 text-slate-600">
        Every stage of manufacturing is measured against clear performance benchmarks — from
        daily floor huddles to management reviews — so quality and delivery timelines stay on
        track.
      </p>
      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        {governancePillars.map((g) => {
          const Icon = g.icon;
          return (
            <div key={g.title} className="flex items-start gap-3 rounded-2xl bg-slate-50 p-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-navy text-white">
                <Icon size={17} />
              </span>
              <div>
                <p className="text-sm font-bold text-navy">{g.title}</p>
                <p className="mt-0.5 text-xs leading-relaxed text-slate-500">{g.desc}</p>
              </div>
            </div>
          );
        })}
      </div>
    </Reveal>

    <Reveal direction="left" delay={120}>
      <div className="overflow-hidden rounded-3xl shadow-sm">
        <img src={gp1} alt="Governance & Performance review" className="h-72 w-full object-cover sm:h-96" loading="lazy" />
      </div>
    </Reveal>
  </div>

  <Reveal delay={200} className="mt-8">
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-5">
      {governanceGallery.map((g) => (
        <div key={g.caption} className="overflow-hidden rounded-2xl bg-slate-50 shadow-sm">
          {/* One single photo per box, filling the frame cleanly */}
          <div className="h-32 w-full overflow-hidden sm:h-36">
            <img
              src={g.img}
              alt={g.caption}
              className="h-full w-full object-cover"
              loading="lazy"
            />
          </div>
          <p className="px-2.5 py-2 text-center text-[11px] font-semibold text-slate-500">{g.caption}</p>
        </div>
      ))}
    </div>
  </Reveal>
</section>


      {/* ---------------- PROCESS ---------------- */}
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <h2 className="text-4xl font-extrabold uppercase leading-none sm:text-5xl lg:text-6xl">
            <span className="hero-shimmer block text-brand-orange">
              OUR PROCESS
            </span>
          </h2>
          <h3 className="mt-4 text-2xl font-bold text-navy sm:text-3xl lg:text-4xl">
            From spec sheet to finished product
          </h3>
        </Reveal>

        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {[
            { icon: FiSettings, title: 'Planning', desc: 'Requirements and specs confirmed with the client upfront.' },
            { icon: FiTool, title: 'Fabrication', desc: 'Built at our own workshop, to spec, under skilled supervision.' },
            { icon: FiShield, title: 'Quality Check', desc: 'Every unit tested and inspected before it leaves the floor.' },
            { icon: FiAward, title: 'Delivery', desc: 'Dispatched and tracked through to on-site handover.' },
          ].map((step, i) => {
            const Icon = step.icon;
            return (
              <Reveal key={step.title} delay={i * 100}>
                <div className="group h-full rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-100 transition duration-300 hover:-translate-y-1.5 hover:shadow-lg">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-orange/10 text-brand-orange transition duration-300 group-hover:scale-110 group-hover:bg-brand-orange group-hover:text-white">
                    <Icon size={22} />
                  </div>
                  <h3 className="mt-4 font-bold text-navy">
                    {i + 1}. {step.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-600">{step.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      {/* ---------------- CTA ---------------- */}
      <section className="px-4 pb-16 sm:px-6 lg:px-8">
        <Reveal className="mx-auto flex max-w-5xl flex-col items-center gap-4 overflow-hidden rounded-3xl bg-navy px-8 py-12 text-center text-white sm:px-16">
          <FiSettings size={28} className="text-brand-orange" />
          <h2 className="text-2xl font-extrabold sm:text-3xl">Have a manufacturing requirement?</h2>
          <p className="max-w-xl text-white/70">
            Share your specifications — transformer rating, steel structure drawing or panel BOQ — and
            our team will confirm feasibility, timeline and pricing.
          </p>
          <div className="mt-2 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 rounded-full bg-brand-orange px-6 py-3 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:bg-brand-orangedark"
            >
              <FiPhoneCall /> Talk to Us
            </Link>
            <a
              href="tel:+9958260035"
              className="inline-flex items-center gap-2 rounded-full border border-white/30 px-6 py-3 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:border-white"
            >
              +91 9958260035 <FiArrowRight />
            </a>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
